module.exports = __webpack_public_path__ + "img/scope-twitch.77fa1141.png";